import { ImportNotesApp } from "./import-types";
import AppleNotesIcon from "@/assets/images/onboarding/apple-notes.png";
import ObsidianIcon from "@/assets/images/onboarding/obsidian-icon.png";
import OtherAppIcon from "@/assets/images/onboarding/other-app-icon.png";
import { clientEnvModule } from "@/modules/client-env";

const NotesApps: ImportNotesApp[] = [
  {
    id: "apple-notes",
    title: "Apple Notes",
    iconImage: AppleNotesIcon,
  },
  {
    id: "obsidian",
    title: "Obsidian",
    iconImage: ObsidianIcon,
  },
  {
    id: "other",
    title: "Other",
    iconImage: OtherAppIcon,
  },
] as const;

/**
 * Returns NotesApps filtered by platform.
 * Apple Notes is only available on macOS.
 */
export const getFilteredNotesApps = (): ImportNotesApp[] => {
  return NotesApps.filter(app => {
    if (app.id === "apple-notes") {
      return clientEnvModule.isMacOs();
    }
    return true;
  });
};
